import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import result from '@/components/result'
import exam from '@/components/exam'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/result',
      name: 'result',
      component: result
    },
    {
      path: '/exam/:name',
      name: 'exam',
      component: exam
    },
    {
      path:'*',
      redirect:'/'
    }
  ]
})
